export default {
    path: 'register_agents',
    
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            cb(null, require('./RegisterAgents').default)
        })
    }
}